import traderaStoresApi from '../../repos/tradera-store'
import timeHasPassed from '../../timeHasPassed'

const state = {
    lastFetchTime: null,
    stores: []
};

const getters = {
    getById: state => id => {
        return state.stores.find(store => store.id === id);
    }
};

const actions = {
    getAll({ state, commit }) {
        if (state.lastFetchTime !== null && !timeHasPassed(state.lastFetchTime, 600)) {
            return Promise.resolve();
        }

        return traderaStoresApi.getAll()
            .then(response => {
                commit('storesFetchSuccess', response.data);
            })
        ;
    }
};

const mutations = {
    storesFetchSuccess(state, stores) {
        state.lastFetchTime = Date.now();
        state.stores = stores;
    },
    resetFetchTime(state) {
        state.lastFetchTime = null;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
